import { useMutation, useQueryClient } from "@tanstack/react-query";

import { petsQueryKey } from "@/hooks/queries/useGetPets";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Pet, UpsertPetRequest } from "@/types";

// Cosmetic upsert (adopt, equip, roll, hide, topper offsets). The server
// strips ledger/balance fields and stores the rest verbatim; creates the pet
// if none exists.
export const useUpsertPet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      userId,
      pet,
      expectedUpdatedAt,
    }: { userId: number } & UpsertPetRequest) => {
      const path = `pets/${userId.toString()}`;
      const res = await guacHttpClient.put<
        Pet,
        HttpResponse<Pet>,
        UpsertPetRequest
      >(path, { pet, expectedUpdatedAt });
      return res.data;
    },
    onSuccess: (updatedPet) => {
      queryClient.setQueryData<Pet[]>(petsQueryKey, (pets) => {
        if (!pets) return pets;
        const exists = pets.some((pet) => pet.userId === updatedPet.userId);
        if (!exists) return [...pets, updatedPet];
        return pets.map((pet) =>
          pet.userId === updatedPet.userId ? updatedPet : pet,
        );
      });
    },
  });
};
